import { __assign } from "tslib";
import React, { useCallback, useEffect } from 'react';
import { Portal } from '../Portal/Portal';
import { cx } from 'emotion';
import { useTheme } from '../../themes';
import { getModalStyles } from './getModalStyles';
import { ModalHeader } from './ModalHeader';
import { IconButton } from '../IconButton/IconButton';
export function Modal(props) {
    var title = props.title, children = props.children, _a = props.isOpen, isOpen = _a === void 0 ? false : _a, _b = props.closeOnEscape, closeOnEscape = _b === void 0 ? true : _b, className = props.className, contentClassName = props.contentClassName, propsOnDismiss = props.onDismiss, onClickBackdrop = props.onClickBackdrop;
    var theme = useTheme();
    var styles = getModalStyles(theme);
    var onDismiss = useCallback(function () {
        if (propsOnDismiss) {
            propsOnDismiss();
        }
    }, [propsOnDismiss]);
    useEffect(function () {
        var onEscKey = function (ev) {
            if (ev.key === 'Esc' || ev.key === 'Escape') {
                onDismiss();
            }
        };
        if (isOpen && closeOnEscape) {
            document.addEventListener('keydown', onEscKey, false);
        }
        else {
            document.removeEventListener('keydown', onEscKey, false);
        }
        return function () {
            document.removeEventListener('keydown', onEscKey, false);
        };
    }, [closeOnEscape, isOpen, onDismiss]);
    if (!isOpen) {
        return null;
    }
    return (React.createElement(Portal, null,
        React.createElement("div", { className: cx(styles.modal, className) },
            React.createElement("div", { className: styles.modalHeader },
                typeof title === 'string' && React.createElement(DefaultModalHeader, __assign({}, props, { title: title })),
                typeof title !== 'string' && title,
                React.createElement("div", { className: styles.modalHeaderClose },
                    React.createElement(IconButton, { surface: "header", name: "times", size: "lg", onClick: onDismiss }))),
            React.createElement("div", { className: cx(styles.modalContent, contentClassName) }, children)),
        React.createElement("div", { className: styles.modalBackdrop, onClick: onClickBackdrop || onDismiss })));
}
function DefaultModalHeader(_a) {
    var icon = _a.icon, iconTooltip = _a.iconTooltip, title = _a.title;
    return React.createElement(ModalHeader, { icon: icon, iconTooltip: iconTooltip, title: title });
}
//# sourceMappingURL=Modal.js.map